'use client';

import { useState } from 'react';
import Link from 'next/link';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Preloader from '@/features/preloader/components/Preloader';
import NextImage from '@/features/Image';
import CommunityPostForm from '@/features/community/CommunityPostForm';
import { getTruncatedText } from '@/utils/getTruncatedText';
import LikeCommunity from '@/features/community/LikeCommunity';
import SocialShareIcons from '@/features/product-details/components/SocialShareIcons';
import parse from 'html-react-parser';
const CommunityPage = () => {
  const [page, setPage] = useState(1);
  const [selectedTag, setSelectedTag] = useState<string>('');

  const {
    data: posts,
    mutate,
    isLoading,
  } = useFetcherCSR(`/api/v2/community-posts?page=${page}&tags=${selectedTag}`);

  const { data: tags } = useFetcherCSR(`/api/v2/community-posts/trending/tags`);

  if (isLoading) return <Preloader />;

  return (
    <div className="community padding-bottom padding-top">
      <div className="container">
        <div className="row g-4">
          <div className="community__sidebar col-lg-3 order-lg-1">
            <div className="community__card community__card--sticky">
              <div className="community__card-body">
                <h2 className="community__title mb-3">Trending Hashtags</h2>
                <ul className="community__tags list-unstyled">
                  {tags?.map(
                    (tag: string, index: number) =>
                      tag && (
                        <li
                          key={index}
                          onClick={() => setSelectedTag(tag)}
                          className="community__tag mb-2"
                        >
                          <Link
                            href={`/community?tags=${tag}`}
                            className="community__tag-button"
                          >
                            # {tag}
                          </Link>
                        </li>
                      )
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="community__main col-lg-6 order-lg-2">
            {/* Create Post Form */}
            <CommunityPostForm />

            {/* Community Posts */}
            {posts?.data?.map((post: any) => (
              <div key={post.id} className="community__post mb-4">
                <div className="community__post-body">
                  <div className="community__post-header d-flex align-items-center mb-3">
                    <NextImage
                      src={
                        post.customer_image || '/images/dummy-pic-female.jpg'
                      }
                      alt={post.customer_name}
                      width={40}
                      height={40}
                      className="community__post-avatar rounded-circle me-3"
                    />
                    <div className="community__post-info">
                      <h5 className="mb-0 fw-medium">{post.customer_name}</h5>
                      <small className="text-muted">{post?.date}</small>
                    </div>
                  </div>

                  {/* {getTruncatedText(post?.description, 2)} */}
                  <Link
                    className="text-black fw-medium"
                    href={`/community/${post?.id}`}
                  >
                    {post?.description && parse(post?.description)}
                  </Link>

                  <Link
                    href={`/community/${post?.id}`}
                    className="community__post-link text-decoration-none text-dark"
                  >
                    {post.banner && (
                      <div className="community__post-image mb-3 ratio ratio-16x9 bg-light rounded">
                        <NextImage
                          src={post?.banner}
                          alt="Post image"
                          fill
                          className="rounded object-fit-cover"
                        />
                      </div>
                    )}
                  </Link>

                  <div className="community__post-actions d-flex gap-3 mb-3">
                    <LikeCommunity post={post} posts={posts} mutate={mutate} />
                    <Link
                      href={`/community/${post?.id}`}
                      className="trk-btn trk-btn--md trk-btn--outline"
                    >
                      <i className="bi bi-chat me-1"></i>
                      Comment ({post?.comments_count})
                    </Link>
                    <div className="border py-1 px-3 rounded-2 border-black">
                      <SocialShareIcons header={false} />
                    </div>
                  </div>

                  {/* Comments */}
                </div>
              </div>
            ))}

            {/* Load More */}
            <button
              disabled={posts?.meta?.current_page === posts?.meta?.last_page}
              onClick={() => setPage(posts?.meta?.current_page + 1)}
              className="community__load-more trk-btn trk-btn--outline w-100"
            >
              Load More Posts
            </button>
          </div>

          <div className="community__guidelines col-lg-3 order-lg-3">
            <div className="community__card community__card--sticky">
              <div className="community__card-body">
                <h2 className="community__title h5 card-title mb-3">
                  Community Guidelines
                </h2>
                <ul className="community__rules list-unstyled small">
                  <li className="mb-2">• Be respectful to others</li>
                  <li className="mb-2">• No spam or self-promotion</li>
                  <li className="mb-2">• Keep content relevant</li>
                  <li className="mb-2">• No offensive language</li>
                  <li className="mb-2">• Report inappropriate content</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityPage;
